<template>
  <div class="c-linear">
    <div class="c-linear__title">Nivel</div>
    <div class="c-linear__main">
      <div v-for="(item, index) in data" :key="index">
        <div class="linear-qualification">
          <div class="linear-qualification__number">
            <strong>{{ index + 1 }}</strong>
          </div>
          <div>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.08448 14.3148C5.35004 14.5182 5.67774 14.4504 6.06195 14.1735L9.00001 12.0152L11.9381 14.1735C12.3223 14.4504 12.6556 14.5182 12.9212 14.3148C13.1811 14.117 13.2376 13.7893 13.085 13.343L11.9268 9.89076L14.8931 7.76067C15.2716 7.48947 15.4355 7.19001 15.3281 6.8736C15.2208 6.56285 14.9213 6.4103 14.4524 6.41595L10.8137 6.43855L9.70627 2.96938C9.56502 2.51737 9.33337 2.27441 9.00001 2.27441C8.6723 2.27441 8.44065 2.51737 8.29375 2.96938L7.18632 6.43855L3.54765 6.41595C3.07869 6.4103 2.78489 6.56285 2.67754 6.8736C2.57018 7.19001 2.72839 7.48947 3.11259 7.76067L6.0789 9.89076L4.91498 13.343C4.76243 13.7893 4.81893 14.117 5.08448 14.3148ZM9.00001 10.8456V3.95815C9.01696 3.95815 9.02261 3.9638 9.03391 3.9977L9.93793 7.08266C10.0227 7.36516 10.1752 7.46122 10.4634 7.44992L13.6783 7.37646C13.7122 7.37646 13.7235 7.38211 13.7292 7.39341C13.7348 7.41037 13.7292 7.41602 13.7009 7.43297L11.051 9.2523C10.7911 9.42746 10.7572 9.59696 10.8532 9.87381L11.9268 12.9079C11.9381 12.9362 11.9381 12.9418 11.9268 12.9531C11.9155 12.9701 11.9042 12.9588 11.8816 12.9475L9.33337 10.9812C9.22036 10.8908 9.10736 10.8456 9.00001 10.8456Z"
                fill="#FFBE17"
              />
              <path
                d="M9.00001 10.8456V3.95815C9.01696 3.95815 9.02261 3.9638 9.03391 3.9977L9.93793 7.08266C10.0227 7.36516 10.1752 7.46122 10.4634 7.44992L13.6783 7.37646C13.7122 7.37646 13.7235 7.38211 13.7292 7.39341C13.7348 7.41037 13.7292 7.41602 13.7009 7.43297L11.051 9.2523C10.7911 9.42746 10.7572 9.59696 10.8532 9.87381L11.9268 12.9079C11.9381 12.9362 11.9381 12.9418 11.9268 12.9531C11.9155 12.9701 11.9042 12.9588 11.8816 12.9475L9.33337 10.9812C9.22036 10.8908 9.10736 10.8456 9.00001 10.8456Z"
                fill="#FFBE17"
              />
            </svg>
          </div>
          <div class="linear-qualification__bar-line">
            <div class="linear-qualification__shell">
              <div
                class="linear-qualification__bar"
                :style="{ width: progress(item.count) + '%' }"
              >
                <!-- <span>{{ item.progress }}%</span> -->
              </div>
            </div>
          </div>
          <div class="linear-qualification__total">{{ item.count }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed :{
    
  },
  methods: {
      progress(count) {
        const result = (count * 100) / this.total
        return parseInt(result)
      }
    }
};
</script>
